import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // 1. Import hook i18n

export default function ActivationFailedPage() {
    const { t } = useTranslation('registration'); // 2. Gunakan namespace registration
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-rose-100 px-4">
            <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full text-center border border-red-100">
                <div className="flex justify-center mb-6">
                    <XCircle className="w-16 h-16 text-red-500" />
                </div>

                <h1 className="text-3xl font-bold text-red-600 mb-3 text-balance">
                    {t('activation_failed.title')}
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6 text-justify">
                    {t('activation_failed.description')}
                </p>

                <Button
                    onClick={() => navigate("/login")}
                    className="w-full bg-gray-600 hover:bg-gray-700 text-white font-semibold py-2"
                >
                    {t('activation_failed.btn_back')}
                </Button>

                <div className="mt-8 border-t border-gray-200 pt-4 text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} Konaspi XII – Universitas Pendidikan Ganesha</p>
                </div>
            </div>
        </div>
    );
}